<template>
  <div class="report">
    <div class="main">
      <div class="top">
        <div class="card tip">
          <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/2af2910482ed974e75a42236030173b4.png" />
          <span>汇总了您近期知识点的学习以及考试记录等内容。</span>
        </div>
      </div>
      <div class="bottom">
        <div class="wrap">
          <div class="title">
            <span class="vertical-line"></span>
            <span>课程报告</span>
          </div>
          <div class="card box course-report" @mousemove="hover(1)" @mouseout="leave">
            <!-- <div class="word-report">
              <div class="tabel-title">
                <i class="el-icon-arrow-left" @click="pre" />
                <span v-if="subjects.length">{{subjects[activeSubjectIndex].name}}</span>
                <i class="el-icon-arrow-right" @click="next" />
              </div>
              <p>学习统计</p>
              <div class="echarts">
                <div class="chart" ref="time"></div>
              </div>
            </div>
            <p>总览</p>
            <div class="overview">
              <div>
                <span>{{overview.learn_word_count}}个</span>
                <span>已学知识点</span>
              </div>
              <div>
                <span>{{overview.learn_examination_count}}个</span>
                <span>当前错题</span>
              </div>
              <p>
                已做<span>100</span>套试卷，其中满分<span>{{overview.grasp_word_count}}</span>次！
              </p>
            </div> -->
            <template v-if="1">
              <img class="bg" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/458f1093279c5c0ee55d25340b7f541c.png" alt="" />
              <div class="tip">
                <p>查看评测</p>
              </div>
              <div v-show="hoverIndex === 1" class="hover">
                <div class="mask"></div>
                <a class="see-btn" @click="toggleScene('courseReport')" href="javascript:;">查看报告</a>
                <div class="tip">
                  <p>在这里可以看到近期所学的</p>
                  <p>全部课程的相关报告</p>
                </div>
              </div>
            </template>
            <div v-else class="no-data">
              <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/a5018184f37de11dcf21188cc80a6fc2.png" alt="" />
              <p>暂无报告哦，</p>
              <p>近期还没有过学习记录呢~</p>
            </div>
          </div>
        </div>
        <div class="wrap">
          <div class="title">
            <span class="vertical-line"></span>
            <span>智能评测</span>
          </div>
          <div class="card box">
            <div class="no-data">
              <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/9f061f9ea3825526377bbff47aebe7c9.png" alt="" />
              <p>努力建设中~</p>
            </div>
          </div>
          <!-- <div class="card box" @mousemove="hover(2)" @mouseout="leave">
            <div class="card fallibility">
              <h2>易错集报告</h2>
              <p class="subject">语文</p>
              <p class="fraction"><span>100</span>分</p>
              <p class="time">测试耗时：12分12秒</p>
              <p class="time">测试时间：2021-06-03 12:12:00</p>
            </div>
            <div class="card fallibility">
              <h2>鲁教版·六上期末测试题一</h2>
              <p class="subject">阶段测试</p>
              <p class="fraction"><span>100</span>分</p>
              <p class="time">测试耗时：12分12秒</p>
              <p class="time">测试时间：2021-06-03 12:12:00</p>
            </div>
            <div v-show="hoverIndex === 2" class="hover">
              <div class="mask"></div>
              <a class="see-btn" @click="toggleScene('ErrorProneSet')" href="javascript:;">查看报告</a>
              <div class="tip">
                <p>来看看你最近测试的成果如何吧！</p>
              </div>
            </div>
            <template v-if="1">
              <img class="bg" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/c46fcc08c85e4d272ced4d27222446ed.png" alt="" />
              <div class="tip">
                <p>查看评测</p>
              </div>
            </template>
            <div v-else class="no-data">
              <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/a5018184f37de11dcf21188cc80a6fc2.png" alt="" />
              <p>暂无报告哦，</p>
              <p>近期还没有过学习记录呢~</p>
            </div>
          </div> -->
        </div>
        <div class="wrap">
          <div class="title">
            <span class="vertical-line"></span>
            <span>闯关里程</span>
          </div>
          <div class="card box">
            <div class="no-data">
              <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/9f061f9ea3825526377bbff47aebe7c9.png" alt="" />
              <p>努力建设中~</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Select, Option, Input, Pagination, Button, DatePicker } from 'element-ui';
import * as echarts from 'echarts';
import report from '@/api/report';
import course from '@/api/course';
import utils from '@/services/utils';
import VanPage from './personal/Page.vue';
import CourseReport from './report/CourseReport.vue';

export default {
  components: {
    CourseReport,
    VanPage,
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input,
    ElPagination: Pagination,
    ElButton: Button,
    ElDatePicker: DatePicker,
  },
  data() {
    return {
      hoverIndex: 0,
      activeSubjectIndex: 0,
      classify: '',
      date: '',
      overview: {},
      subjects: [],
      classifyList: [],
    };
  },
  mounted() {
  },
  created() {
  },
  methods: {
    leave() {
      this.hoverIndex = 0;
    },
    hover(index) {
      this.hoverIndex = index;
    },
    pre() {
      if (this.activeSubjectIndex === 0) {
        utils.message('已经到头了');
      } else {
        this.activeSubjectIndex -= 1;
      }
    },
    next() {
      if (this.activeSubjectIndex === this.subjects.length - 1) {
        utils.message('已经到头了');
      } else {
        this.activeSubjectIndex += 1;
      }
    },
    getWeekWords() {
      report.getWeekWords({subject_code: this.subjects[this.activeSubjectIndex].code})
        .then((data) => {
          console.log(data);
        });
    },
    toggleScene(scene) {
      this.$emit('change', { scene, params: { course: this.subjects[this.activeSubjectIndex] } });
    },
    getSubjectList() {
      course.getWrongBookCourses()
        .then((data) => {
          this.subjects = data;
          this.getWeekWords();
          this.getOverview();
        })
    },
    getOverview() {
      report.getOverview({
        subject_code: this.subjects[this.activeSubjectIndex].code,
      }).then((data) => {
        this.overview = data;
      });
    },
    renderTimeChart() {
      const chartDom = this.$refs.time;
      const myChart = echarts.init(chartDom);

      const option = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
          axisLine: {
            lineStyle: {
              color: '#E9EFF3',
            }
          },
          axisLabel: {
            color: '#5A5FEF',
          },
          axisTick: {
            show: false,
          },
        },
        tooltip: {
          trigger: 'item',
        },
        legend: {
          data: ['单词数量'],
          textStyle: {
            color: '#117CF7'
          },
          top: '0px',
          right: '0px',
        },
        grid: {
          top: '50px',
          left: '0%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          splitNumber: 4,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#5A5FEF',
            }
          },
          splitLine: {
            show: true,
            lineStyle:{
              color: '#E9EFF3',
              width: 1,
              type: 'solid'
            }
          },
        },
        series: [{
          name: '单词数量',
          data: [50, 100, 120, 110, 180],
          type: 'line',
          color: '#117CF7',
          showSymbol: false,
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ADCBF8' },
                { offset: 1, color: '#F2F5F9' }
              ])
            }
          },
        }]
      };
      myChart.setOption(option);
      window.onresize = myChart.resize;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .report {
    position: absolute;
    left: calc(50% - 44vw + 40px);
    top: calc(50% - 45vh);
    overflow: hidden;
    .main {
      padding: 30px;
      box-sizing: border-box;
      width: 88vw;
      height: 90vh;
      background-color: #fff;
      border-radius: 24px;
      .card {
        border-radius: 18px;
        box-shadow: 0px 0px 10px rgba(0, 56, 216, 0.3);
      }
      .title {
        position: relative;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        line-height: 6vh;
        font-size: 2vh;
        font-weight: 700;
        .vertical-line {
          display: inline-block;
          width: 3px;
          height: 15px;
          margin-right: 1vh;
          background: $primary;
          border-radius: 18px;
        }
      }
      .no-data {
        height: 90%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 80%;
        }
        p {
          margin: 0;
          line-height: 3.5vh;
          font-size: 2.5vh!important;
          font-weight: normal!important;;
          color: #999;
        }
      }
      .top {
        height: 8%;
        .tip {
          padding: 0 2%;
          display: flex;
          align-items: center;
          height: 100%;
          img {
            height: 50%;
          }
          span {
            margin-left: 2%;
            font-size: 2.5vh;
            color: $primary;
          }
        }
      }
      .bottom {
        height: 92%;
        display: flex;
        justify-content: space-between;
        .wrap {
          width: 30%;
          height: 100%;
          .box {
            position: relative;
            box-sizing: border-box;
            height: calc(100% - 6vh);
            width: 100%;
            overflow: hidden;
            .bg {
              width: 100%;
              height: 100%;
            }
            .tip {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              color: #fff;
              background-color: #5A5FEF;
              z-index: 1;
              p {
                font-size: 2.2vh;
                font-weight: normal;
              }
            }
            .see-btn {
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 8;
              display: block;
              text-align: center;
              width: 100%;
              line-height: 8vh;
              color: #fff;
              font-size: 2vh;
              font-weight: bold;
              background-color: #5A5FEF;
            }
            p {
              text-align: center;
              font-weight: bold;
              font-size: 1.8vh;
            }
            .hover {
              position: absolute;
              top: 0;
              height: 100%;
              width: 100%;
              .mask {
                height: 100%;
                width: 100%;
                background-color: #000;
                opacity: .3;
                z-index: 7;
              }
              .see-btn {
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                line-height: 5vh;
                width: 40%;
                height: 5vh;
                border-radius: 14px;
              }
              .tip {
                z-index: 2;
              }
            }
          }
          .course-report {
            .word-report {
              box-sizing: border-box;
              .tabel-title {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 2vh;
                span {
                  font-size: 2.5vh;
                  font-weight: bold;
                  color: #5A5FEF;
                }
                i {
                  padding: 1%;
                  color: #5A5FEF;
                  font-weight: bold;
                  font-size: 3vh;
                  cursor: pointer;
                  border-radius: 50%;
                  background-color: #ebecfd;
                }
              }
              .echarts {
                .chart {
                  min-height: 150px;
                  height: 25vh;
                  width: 100%;
                }
              }
            }
            .overview {
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
              height: 30%;
              p {
                margin: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 40%;
                font-size: 2vh;
                font-weight: normal;
                border-radius: 10px;
                border: 2px solid #5A5FEF;
                span {
                  color: $primary;
                  font-weight: bold;
                }
              }
              div {
                margin-bottom: 6%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 46%;
                height: 40%;
                border: 2px solid #5A5FEF;
                border-radius: 10px;
                :first-child {
                  padding-bottom: 5%;
                  font-size: 3vh;
                  color: $primary;
                }
                :last-child {
                  font-size: 2vh;
                }
              }
            }
          }
          .fallibility {
            margin: 2.5vh auto 0;
            padding: 2vh;
            width: 80%;
            h2 {
              margin: 0;
              font-size: 2.5vh;
              color: #5A5FEF;
            }
            p {
              margin: 0;
            }
            .subject {
              line-height: 4vh;
              font-size: 2vh;
              color: #5A5FEF;
            }
            .fraction {
              text-align: center;
              line-height: 7vh;
              color: #5A5FEF;
              font-size: 3vh;
              span {
                font-size: 6vh;
                font-weight: bold;
              }
            }
            .time {
              line-height: 4vh;
              font-size: 2vh;
            }
          }
        }

      }
    }
  }
</style>
